/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultsInner } from './ResultsInner';
import {
    ResultsInnerFromJSON,
    ResultsInnerFromJSONTyped,
    ResultsInnerToJSON,
} from './ResultsInner';

/**
 * 
 * @export
 * @interface ControlPaginatedAlertResponse
 */
export interface ControlPaginatedAlertResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedAlertResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedAlertResponse
     */
    page_size: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedAlertResponse
     */
    total: number;
    /**
     * 
     * @type {Array<ResultsInner>}
     * @memberof ControlPaginatedAlertResponse
     */
    results: Array<ResultsInner>;
}

/**
 * Check if a given object implements the ControlPaginatedAlertResponse interface.
 */
export function instanceOfControlPaginatedAlertResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "page_size" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlPaginatedAlertResponseFromJSON(json: any): ControlPaginatedAlertResponse {
    return ControlPaginatedAlertResponseFromJSONTyped(json, false);
}

export function ControlPaginatedAlertResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedAlertResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'page_size': json['page_size'],
        'total': json['total'],
        'results': ((json['results'] as Array<any>).map(ResultsInnerFromJSON)),
    };
}

export function ControlPaginatedAlertResponseToJSON(value?: ControlPaginatedAlertResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'total': value.total,
        'results': ((value.results as Array<any>).map(ResultsInnerToJSON)),
    };
}

